import authenticatedApi, {AuthenticatedApiError} from "../AuthenticatedApi";
import {GetAgency} from "../../interfaces/Agency";
import {EnergyRecompute} from "../../interfaces/plant/EnergyRecompute";
import {Equipment} from "../../interfaces/Equipment";
import {CreateUser, GetInstallator, UpdateUser, UserSearch} from "../../interfaces/User";
import {GetClient} from "../../interfaces/client/Client";
import {
  CampaignTargeting,
  SendCampaignNotification,
  SendTestNotification,
} from "../../interfaces/notification/Notification";
import {CreateClient, UpdateClient, GetClientDetail} from "../../interfaces/client/Client";
import {CreatePlant, UpdatePlantPayload, GetPlantDetail} from "../../interfaces/plant/Plant";
import {EssType} from "../../interfaces/plant/EssType";
import {TrackerType} from "../../interfaces/plant/TrackerType";
import {PowerImmersionHeater} from "../../interfaces/PowerImmersionHeater";
import {PowerInverter} from "../../interfaces/PowerInverter";
import {PowerPlant} from "../../interfaces/PowerPlant";
import {Weather} from "../../interfaces/Weather";
import {ListUUIDTrackerAlarmTypeInterface} from "../../app/scada/remote/ListUUIDTrackerAlarmTypeInterface";
import {TrackerWind} from "../../interfaces/TrackerWind";
import {TrackerPosition} from "../../interfaces/TrackerPosition";
import dayjs, {Dayjs} from "dayjs";
import {TrackerAlarm} from "../../interfaces/tracker/TrackerAlarm";
import {ImmersionHeaterAlarm} from "../../interfaces/immersion_heater/ImmersionHeaterAlarm";
import {PlantSearch} from "../../interfaces/PlantSearch";
import {PlantStatus} from "../../interfaces/PlantStatus";
import {TrackerStatus} from "../../interfaces/TrackerStatus";
import {ImmersionHeaterStatus} from "../../interfaces/immersion_heater/ImmersionHeaterStatus";
import {MeterStatus} from "../../interfaces/MeterStatus";
import {CurrentAuthorization} from "../../interfaces/CurrentAuthorization";
import {GetAlarmNotViewedBySav} from "../../interfaces/GetAlarmNotViewedBySav";
import {EssStatus} from "../../interfaces/ess/EssStatus";
import AgencyModel from "../../app/platform/agencies/model";

import {MapOfPlantStatusesItem} from "../../interfaces/MapOfPlantStatusesItem";
import {CurrentAlarmItem} from "../../interfaces/CurrentAlarmItem";
import {PlantStatusType} from "../../interfaces/PlantStatusTypes";
import {REACT_APP_API_V2_URL} from "../../config";
import {TrackerInternetStatus} from "../../interfaces/TrackerInternetStatus";
import {SetPvPanel} from "../../interfaces/tracker/SetPvPanel";
import {PvPanelType} from "../../interfaces/tracker/PvPanelType";
import {SetPlantPowerFactor} from "../../interfaces/plant/SetPlantPowerFactor";
import {MeterAlarm} from "../../interfaces/meter/MeterAlarm";
import {PlantAlarm} from "../../interfaces/plant/PlantAlarm";
import {GetAlarmType} from "../../interfaces/alarms/GetAlarmType";
import {AlarmType} from "../../interfaces/AlarmType";
import Tag from "../../interfaces/Tag";
import {ControlPlantStatus} from "../../interfaces/control/ControlPlantStatus";
import {EssAlarm} from "../../interfaces/ess/EssAlarm";
import {SolarGatewayStatus} from "../../interfaces/solar_gateway/SolarGatewayStatus";
import {SolarGatewayAlarm} from "../../interfaces/solar_gateway/SolarGatewayAlarm";
import {EssSoC} from "../../interfaces/ess/EssSoC";
import {Jws} from "../../interfaces/Jws";
import {EntityProperty} from "../../interfaces/EntityProperty";
import {EntityTypeEnum} from "../../enums/EntityTypeEnum";
import i18next from "i18next";

const baseUrl = REACT_APP_API_V2_URL;
const deleteEssEndpoint = "v2/human/ess/delete_ess";
const essTypes = "v2/human/reference/ess/ess_types";
const powerPlantMinutesEndpoint = "v2/human/power_plant_minutes";
const powerInverterMinutesEndpoint = "v2/human/power_inverter_minutes";
const trackersEndpoint = "v2/human/trackers";
const meterEndpoint = "v2/human/meters";
const plantEndpoint = "v2/human/plants";
const agenciesEndpoint = "v2/human/agencies";
const createAgencyEndpoint = "v2/human/agency/create";
const updateAgencyEndpoint = "v2/human/agency/update";
const deleteAgencyEndpoint = "v2/human/agency/delete";
const immersionHeatersEndpoint = "v2/human/immersion_heaters";
const solarGatewaysEndpoint = "v2/human/solar_gateways";
const dataImmersionHeaterMinutesEndpoint = "v2/human/data_immersion_heater_minutes";
const weathersEndpoint = "v2/human/weathers";
const trackersTypes = "v2/human/trackers_types";
const trackerAlarmTypeEndpoint = "v2/human/reference/alarm/tracker_alarm_types";
const restartTrackingByAlarmEndpoint = "v2/human/remote_control/restart_tracking_by_alarm";
const trackerWindSpeedsEndpoint = "v2/human/tracker_wind_speeds";
const trackerPositionsEndpoint = "v2/human/tracker_positions";
const trackerAlarmsEndpoint = "v2/human/tracker_alarms";
const meterAlarmsEndpoint = "v2/human/meter_alarms";
const plantAlarmsEndpoint = "v2/human/plant_alarms";
const immersionHeaterAlarmsEndpoint = "v2/human/immersion_heater_alarms";
const essAlarmsEndpoint = "v2/human/ess/ess_alarms";
const essStateOfChargeEndpoint = "v2/human/ess/ess_state_of_charge_minutes";
const searchPlantsEndpoint = "v2/human/search_plants";
const searchUsersEndpoint = "v2/human/search_users";
const searchClientsEndpoint = "v2/human/search_clients";
const plantStatusEndpoint = "v2/human/scada/plant_full_statuses";
const trackerStatusEndpoint = "v2/human/scada/tracker_full_statuses";
const immersionHeaterStatusEndpoint = "v2/human/scada/immersion_heater_full_statuses";
const meterStatusEndpoint = "v2/human/scada/meter_full_statuses";
const currentAuthorizationEndpoint = "v2/human/current_authorization";
const getAlarmNotViewedBySavEndpoint = "v2/human/get_alarm_not_viewed_by_sav";
const setAlarmSavStatusAsViewedEndpoint = "v2/human/set_alarm_sav_status_as_viewed";
const restartTrackingEndpoint = "v2/human/remote_control/restart_tracking";
const startSSHEndpoint = "v2/human/remote_control/begin_ssh";
const stopSSHEndpoint = "v2/human/remote_control/end_ssh";
const startFlatEndpoint = "v2/human/remote/start_flat";
const stopFlatEndpoint = "v2/human/remote/stop_flat";
const graphMigrationEndpoint = "v2/human/graph-migration";
const RECOMPUTE_PERIOD_MODE = 5;
const energyRecomputeEndpoint = "v2/human/plant/{plantId}/energy-recompute";
const purgeStatusEndpoint = "v2/human/purge_status";
const nominalPowerComputeEndpoint = "v2/human/nominal-power-compute";
const downloadConfiguratorEndpoint = "v2/human/software/configurator";
const essEndpoint = "v2/human/ess/ess";
const essStatusEndpoint = "v2/human/ess/status";
const installatorsEndpoint = "v2/human/user/installators";
const createUserEndpoint = "v2/human/user/create";
const updateUserEndpoint = "v2/human/user/update";
const deleteUserEndpoint = "v2/human/user/delete";
const createClientEndpoint = "v2/human/client/create";
const updateClientEndpoint = "v2/human/client/update";
const deleteClientEndpoint = "v2/human/client/delete";
const sendCampaignNotificationEndpoint = "v2/human/notification/send_campaign";
const countCampaignRecipientsEndpoint = "v2/human/notification/campaign_recipient_count";
const sendTestNotificationEndpoint = "v2/human/notification/send_test";
const uploadNotificationImageEndpoint = "v2/human/notification/image";
const detailClientEndpoint = "v2/human/client/detail";
const sendEmailResetPasswordClientEndpoint = "v2/human/client/email_reset_password";
const mapOfPlantStatusesEndpoint = "v2/human/scada/map_of_plant_full_statuses";
const currentAlarmsEndpoint = "v2/human/scada/current_alarms";
const plantStatusTypesEndpoint = "v2/human/scada/plant_status_types";
const createPlantEndpoint = "v2/human/plant/create";
const updatePlantEndpoint = "v2/human/plant/update";
const deletePlantEndpoint = "v2/human/plant/delete";
const detailPlantEndpoint = "v2/human/plant/detail";
const updatePlantPowerFactorEndpoint = "v2/human/set_plant_power_factor";
const deleteTrackerEndpoint = "v2/human/tracker/delete";
const trackerInternetStatusEndpoint = "v2/human/tracker/{trackerId}/internet_status";
const updateEntityPropertyEndpoint = "v2/human/{entity}/{id}/set_properties";
const updateTrackerPvPanelEndpoint = "v2/human/set_tracker_pvpanel";
const pvPanelTypesEndpoint = "v2/human/reference/tracker/pv_panel_types";
const getAlarmTypesEndpoint = "v2/human/get_alarm_types";
const getPlantTagsEndpoint = "v2/human/tags";
const equipmentsEndpoint = "v2/human/scada/plant/equipments";
const alarmEndsEndpoint = "v2/human/alarm_ends";
const controlPlantStatusEndpoint = "v2/human/control/plants/statuses";
const getMercureJwsEndpoint = "v2/human/mercure/jws";
const setProfileApprovalEndpoint = "v2/human/set_profile_approval";

const apiV2 = {
  deleteEss: async function (essId: string): Promise<Response> {
    const url = `${baseUrl}/${deleteEssEndpoint}`;
    return await authenticatedApi.post(url, {essId: essId});
  },
  essTypes: async function (): Promise<Array<EssType>> {
    const url = `${baseUrl}/${essTypes}`;
    const response = await authenticatedApi.get(url);
    const data = response.json();
    return data;
  },
  trackers: async function (plantId: number): Promise<Response> {
    const url = `${baseUrl}/${trackersEndpoint}?plant=${plantId}`;
    return authenticatedApi.get(url);
  },
  meter: async function (plantId: number): Promise<Response> {
    const url = `${baseUrl}/${meterEndpoint}?plant=${plantId}`;
    return authenticatedApi.get(url);
  },
  plant: async function (plantId: number): Promise<Response> {
    const url = `${baseUrl}/${plantEndpoint}/${plantId}`;
    return authenticatedApi.get(url);
  },
  immersionHeaters: async function (plantId: number): Promise<Response> {
    const url = `${baseUrl}/${immersionHeatersEndpoint}?plant=${plantId}`;
    return authenticatedApi.get(url);
  },
  solarGateways: async function (plantId: number): Promise<Response> {
    const url = `${baseUrl}/${solarGatewaysEndpoint}?plant=${plantId}`;
    return authenticatedApi.get(url);
  },
  powerInverter: async function (startDate: Dayjs, endDate: Dayjs, trackerId: number): Promise<Array<PowerInverter>> {
    const url = `${baseUrl}/${powerInverterMinutesEndpoint}?date[after]=${startDate.format("YYYY-MM-DD HH:mm:ss")}&date[before]=${endDate.format("YYYY-MM-DD HH:mm:ss")}&tracker=${trackerId}`;
    const response = await authenticatedApi.get(url);
    const data = response.json();
    return data;
  },
  powerImmersionHeater: async function (
    startDate: Dayjs,
    endDate: Dayjs,
    immersionHeaterId: string,
  ): Promise<Array<PowerImmersionHeater>> {
    const url = `${baseUrl}/${dataImmersionHeaterMinutesEndpoint}?date[after]=${startDate.format("YYYY-MM-DD HH:mm:ss")}&date[before]=${endDate.format("YYYY-MM-DD HH:mm:ss")}&immersionHeater=${immersionHeaterId}`;
    const response = await authenticatedApi.get(url);
    const data = response.json();
    return data;
  },
  powerPlant: async function (startDate: Dayjs, endDate: Dayjs, plantId: number): Promise<Array<PowerPlant>> {
    const url = `${baseUrl}/${powerPlantMinutesEndpoint}?date[after]=${startDate.format("YYYY-MM-DD HH:mm:ss")}&date[before]=${endDate.format("YYYY-MM-DD HH:mm:ss")}&plant=${plantId}`;
    const response = await authenticatedApi.get(url);
    const data = response.json();
    return data;
  },
  weather: async function (startDate: Dayjs, endDate: Dayjs, plantId: number): Promise<Array<Weather>> {
    const url = `${baseUrl}/${weathersEndpoint}?begin=${startDate.format("YYYY-MM-DD HH:mm:ss")}&end=${endDate.format("YYYY-MM-DD HH:mm:ss")}&plant=${plantId}`;
    const response = await authenticatedApi.get(url);
    const data = response.json();
    return data;
  },
  trackerAlarmType: async function (): Promise<Array<AlarmType>> {
    return authenticatedApi
      .get(`${baseUrl}/${trackerAlarmTypeEndpoint}`)
      .then((response) => response.json())
      .then((data) => data);
  },
  restartByAlarm: async function (listSelectedTrackerAlarmType: ListUUIDTrackerAlarmTypeInterface): Promise<Response> {
    const url = `${baseUrl}/${restartTrackingByAlarmEndpoint}`;
    return authenticatedApi.post(url, listSelectedTrackerAlarmType);
  },
  trackerWindSpeed: async function (startDate: Dayjs, endDate: Dayjs, trackerId: number): Promise<Array<TrackerWind>> {
    const url = `${baseUrl}/${trackerWindSpeedsEndpoint}?date[after]=${startDate.format("YYYY-MM-DD HH:mm:ss")}&date[before]=${endDate.format("YYYY-MM-DD HH:mm:ss")}&trackerId=${trackerId}`;
    const response = await authenticatedApi.get(url);
    const data = response.json();
    return data;
  },
  trackerPositions: async function (
    startDate: Dayjs,
    endDate: Dayjs,
    trackerId: number,
  ): Promise<Array<TrackerPosition>> {
    const url = `${baseUrl}/${trackerPositionsEndpoint}?date[after]=${startDate.format("YYYY-MM-DD HH:mm:ss")}&date[before]=${endDate.format("YYYY-MM-DD HH:mm:ss")}&trackerId=${trackerId}`;
    const response = await authenticatedApi.get(url);
    const data = response.json();
    return data;
  },
  trackerAlarms: async function (startDate: Dayjs, endDate: Dayjs, trackerId: number): Promise<Array<TrackerAlarm>> {
    const url = `${baseUrl}/${trackerAlarmsEndpoint}?date[after]=${startDate.format("YYYY-MM-DD HH:mm:ss")}&date[before]=${endDate.format("YYYY-MM-DD HH:mm:ss")}&trackerId=${trackerId}`;
    const response = await authenticatedApi.get(url);
    const data = response.json();
    return data;
  },
  meterAlarms: async function (startDate: Dayjs, endDate: Dayjs, meterId: number): Promise<Array<MeterAlarm>> {
    const url = `${baseUrl}/${meterAlarmsEndpoint}?date[after]=${startDate.format("YYYY-MM-DD HH:mm:ss")}&date[before]=${endDate.format("YYYY-MM-DD HH:mm:ss")}&meterId=${meterId}`;
    const response = await authenticatedApi.get(url);
    const data = response.json();
    return data;
  },
  plantAlarms: async function (startDate: Dayjs, endDate: Dayjs, plantId: number): Promise<Array<PlantAlarm>> {
    const url = `${baseUrl}/${plantAlarmsEndpoint}?date[after]=${startDate.format("YYYY-MM-DD HH:mm:ss")}&date[before]=${endDate.format("YYYY-MM-DD HH:mm:ss")}&plantId=${plantId}`;
    const response = await authenticatedApi.get(url);
    const data = response.json();
    return data;
  },
  immersionHeaterAlarms: async function (
    startDate: Dayjs,
    endDate: Dayjs,
    immersionHeaterId: string,
  ): Promise<Array<ImmersionHeaterAlarm>> {
    const url = `${baseUrl}/${immersionHeaterAlarmsEndpoint}?date[after]=${startDate.format("YYYY-MM-DD HH:mm:ss")}&date[before]=${endDate.format("YYYY-MM-DD HH:mm:ss")}&immersionHeaterId=${immersionHeaterId}`;
    const response = await authenticatedApi.get(url);
    const data = response.json();
    return data;
  },
  essStateOfCharge: async function (startDate: Dayjs, endDate: Dayjs, essId: string): Promise<Array<EssSoC>> {
    const url = `${baseUrl}/${essStateOfChargeEndpoint}?date[after]=${startDate.format("YYYY-MM-DD HH:mm:ss")}&date[before]=${endDate.format("YYYY-MM-DD HH:mm:ss")}&ess=${essId}&page=1`;
    const response = await authenticatedApi.get(url);
    const data = response.json();
    return data;
  },
  searchPlants: async function (
    search: string,
    tags: string[] = [],
    equipements: string[] = [],
    agencies: number[] = [],
    page: number = 1,
  ): Promise<{items: PlantSearch[]; total: number}> {
    const url = new URL(`${baseUrl}/${searchPlantsEndpoint}`);
    url.searchParams.set("search", search);
    if (tags.length > 0) {
      url.searchParams.set("tags", tags.join(","));
    }
    if (equipements.length > 0) {
      url.searchParams.set("equipements", equipements.join(","));
    }
    if (agencies.length > 0) {
      url.searchParams.set("agencies", agencies.join(","));
    }
    url.searchParams.set("page", String(page));
    const response = await authenticatedApi.get(url.href, true, "application/ld+json");
    const json = await response.json();
    return {items: json["hydra:member"] ?? [], total: json["hydra:totalItems"] ?? 0};
  },
  searchPlantById: async function (id: number): Promise<Array<PlantSearch>> {
    const url = `${baseUrl}/${searchPlantsEndpoint}?id=${id}`;
    const response = await authenticatedApi.get(url, true, "application/ld+json");
    const json = await response.json();
    return json["hydra:member"] ?? [];
  },
  searchUsers: async function (
    search: string,
    agencies: number[] = [],
    roles: string[] = [],
    page: number = 1,
  ): Promise<{items: UserSearch[]; total: number}> {
    const url = new URL(`${baseUrl}/${searchUsersEndpoint}`);
    url.searchParams.set("search", search);
    url.searchParams.set("page", String(page));
    if (agencies.length > 0) {
      url.searchParams.set("agencies", agencies.join(","));
    }
    if (roles.length > 0) {
      url.searchParams.set("roles", roles.join(","));
    }
    const response = await authenticatedApi.get(url.href, true, "application/ld+json");
    const json = await response.json();
    return {items: json["hydra:member"] ?? [], total: json["hydra:totalItems"] ?? 0};
  },
  searchClients: async function (search: string, page: number = 1): Promise<{items: GetClient[]; total: number}> {
    const url = new URL(`${baseUrl}/${searchClientsEndpoint}`);
    url.searchParams.set("search", search);
    url.searchParams.set("page", String(page));
    const response = await authenticatedApi.get(url.href, true, "application/ld+json");
    const json = await response.json();
    return {items: json["hydra:member"] ?? [], total: json["hydra:totalItems"] ?? 0};
  },
  getPlantImage: async function (urlStream: string): Promise<string> {
    const url = `${baseUrl}${urlStream}`;
    return await authenticatedApi.getImage(url);
  },
  plantStatus: async function (plantId: number): Promise<PlantStatus> {
    const url = `${baseUrl}/${plantStatusEndpoint}/${plantId}`;
    const response = await authenticatedApi.get(url);
    const data = response.json();
    return data;
  },
  trackerStatus: async function (trackerId: number): Promise<TrackerStatus> {
    const url = `${baseUrl}/${trackerStatusEndpoint}/${trackerId}`;
    const response = await authenticatedApi.get(url);
    const data = response.json();
    return data;
  },
  immersionHeaterStatus: async function (immersionHeaterId: string): Promise<ImmersionHeaterStatus> {
    const url = `${baseUrl}/${immersionHeaterStatusEndpoint}/${immersionHeaterId}`;
    const response = await authenticatedApi.get(url);
    const data = response.json();
    return data;
  },
  meterStatus: async function (meterId: number): Promise<MeterStatus> {
    const url = `${baseUrl}/${meterStatusEndpoint}/${meterId}`;
    const response = await authenticatedApi.get(url);
    const data = response.json();
    return data;
  },
  currentAuthorization: async function (): Promise<CurrentAuthorization> {
    const url = `${baseUrl}/${currentAuthorizationEndpoint}`;
    const response = await authenticatedApi.get(url);
    const data = response.json();
    return data;
  },
  getAlarmNotViewedBySav: async function (
    plantId?: number,
    begin?: string | null,
    end?: string | null,
    references?: string[] | null,
    tags?: string[] | null,
    interventionDate?: string | null,
    equipments?: string[] | null,
  ): Promise<Array<GetAlarmNotViewedBySav>> {
    let url = `${baseUrl}/${getAlarmNotViewedBySavEndpoint}`;
    const params = [];
    if (plantId) {
      params.push(`plant=${plantId}`);
    }
    if (begin) {
      params.push(`date[after]=${begin}`);
    }
    if (end) {
      params.push(`date[before]=${dayjs(end).endOf("day").format("YYYY-MM-DD HH:mm:ss")}`);
    }
    if (references && references.length > 0) {
      params.push(`references=${references.join(",")}`);
    }
    if (tags && tags.length > 0) {
      params.push(`tags=${tags.join(",")}`);
    }
    if (interventionDate) {
      params.push(`interventionDate=${interventionDate}`);
    }
    if (equipments && equipments.length > 0) {
      params.push(`equipments=${equipments.join(",")}`);
    }
    if (params.length > 0) {
      url += `?${params.join("&")}`;
    }
    const response = await authenticatedApi.get(url);
    return response.json();
  },
  setAlarmSavStatusAsViewed: async function (alarmId: string): Promise<Response> {
    const url = `${baseUrl}/${setAlarmSavStatusAsViewedEndpoint}`;
    return authenticatedApi.post(url, {id: alarmId});
  },
  restartTracking: async function (trackerId: number): Promise<Response> {
    const url = `${baseUrl}/${restartTrackingEndpoint}`;
    return authenticatedApi.post(url, {trackerId: trackerId});
  },
  startSSH: async function (trackerId: number): Promise<Response> {
    const url = `${baseUrl}/${startSSHEndpoint}`;
    return authenticatedApi.post(url, {trackerId: trackerId});
  },
  stopSSH: async function (trackerId: number): Promise<Response> {
    const url = `${baseUrl}/${stopSSHEndpoint}`;
    return authenticatedApi.post(url, {trackerId: trackerId});
  },
  startFlat: async function (trackerId: number): Promise<Response> {
    const url = `${baseUrl}/${startFlatEndpoint}`;
    return authenticatedApi.post(url, {trackerId: trackerId});
  },
  stopFlat: async function (trackerId: number): Promise<Response> {
    const url = `${baseUrl}/${stopFlatEndpoint}`;
    return authenticatedApi.post(url, {trackerId: trackerId});
  },
  // recalcule chaque journée de beginDate à endDate inclus (mode 5 de l'API, MODE_RECOMPUTE_PERIOD)
  graphMigration: async function (plantId: number, beginDate: string, endDate: string): Promise<Response> {
    const url = `${baseUrl}/${graphMigrationEndpoint}`;
    return authenticatedApi.post(url, {
      plantId,
      date: beginDate,
      endDate,
      mode: RECOMPUTE_PERIOD_MODE,
    });
  },
  // null si aucun recalcul n'a été lancé sur le site ; sans loader global, l'appel est répété pendant un recalcul
  energyRecompute: async function (plantId: number): Promise<EnergyRecompute | null> {
    const url = `${baseUrl}/${energyRecomputeEndpoint.replace("{plantId}", String(plantId))}`;
    try {
      const response = await authenticatedApi.get(url, false);
      return await response.json();
    } catch (error) {
      if (error instanceof AuthenticatedApiError && error.response.status === 404) {
        return null;
      }
      throw error;
    }
  },
  purgeStatus: async function (plantId: number): Promise<Response> {
    const url = `${baseUrl}/${purgeStatusEndpoint}`;
    return authenticatedApi.post(url, {plantId});
  },
  nominalPowerCompute: async function (plantId: number): Promise<Response> {
    const url = `${baseUrl}/${nominalPowerComputeEndpoint}`;
    return authenticatedApi.post(url, {plantId});
  },
  installators: async function (agencyId?: number | null): Promise<Array<GetInstallator>> {
    const url = new URL(`${baseUrl}/${installatorsEndpoint}`);
    if (agencyId) {
      url.searchParams.set("agencyId", String(agencyId));
    }
    const response = await authenticatedApi.get(url.href);
    return await response.json();
  },
  createUser: async function (user: CreateUser): Promise<Response> {
    const url = `${baseUrl}/${createUserEndpoint}`;
    return await authenticatedApi.post(url, user);
  },
  updateUser: async function (user: UpdateUser): Promise<Response> {
    const url = `${baseUrl}/${updateUserEndpoint}`;
    return await authenticatedApi.post(url, user);
  },
  deleteUser: async function (userId: number): Promise<Response> {
    const url = `${baseUrl}/${deleteUserEndpoint}`;
    // authenticatedApi.post envoie en application/ld+json : en application/json, l'API refuse
    // une clé id dans le corps d'un POST
    return await authenticatedApi.post(url, {id: userId});
  },
  detailClient: async function (clientId: number): Promise<GetClientDetail> {
    const url = `${baseUrl}/${detailClientEndpoint}/${clientId}`;
    const response = await authenticatedApi.get(url);
    return response.json();
  },
  createClient: async function (client: CreateClient): Promise<Response> {
    const url = `${baseUrl}/${createClientEndpoint}`;
    // don't even send id when creating client
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {id, ...payload} = client;
    return await authenticatedApi.post(url, payload);
  },
  updateClient: async function (client: UpdateClient): Promise<Response> {
    const url = `${baseUrl}/${updateClientEndpoint}`;
    return await authenticatedApi.post(url, client);
  },
  deleteClient: async function (clientId: number): Promise<Response> {
    const url = `${baseUrl}/${deleteClientEndpoint}`;
    return await authenticatedApi.post(url, {clientId: clientId});
  },
  sendEmailResetPasswordClient: async function (clientId: number): Promise<Response> {
    const url = `${baseUrl}/${sendEmailResetPasswordClientEndpoint}`;
    return await authenticatedApi.post(url, {clientId: clientId});
  },
  sendCampaignNotification: async function (campaign: SendCampaignNotification): Promise<Response> {
    const url = `${baseUrl}/${sendCampaignNotificationEndpoint}`;
    return await authenticatedApi.post(url, campaign);
  },
  /**
   * Envoie la notification en relecture, à soi-même et aux utilisateurs désignés.
   *
   * Renvoie le nombre de destinataires réellement servis : api-v2 écarte silencieusement les
   * adresses hors périmètre ou correspondant à un client, et c'est ce compte qui le révèle.
   */
  sendTestNotification: async function (notification: SendTestNotification): Promise<number> {
    const url = `${baseUrl}/${sendTestNotificationEndpoint}`;
    const response = await authenticatedApi.post(url, notification);
    const data = await response.json();

    return data.recipientCount;
  },
  /**
   * Nombre de clients qu'une campagne toucherait, sans rien envoyer.
   *
   * api-v2 le calcule avec le service qui résout les destinataires de l'envoi : le nombre
   * affiché est celui qui sera servi, pas une estimation.
   */
  countCampaignRecipients: async function (targeting?: CampaignTargeting): Promise<number> {
    const url = `${baseUrl}/${countCampaignRecipientsEndpoint}`;
    const response = await authenticatedApi.post(url, {targeting});
    const data = await response.json();

    return data.count;
  },
  uploadNotificationImage: async function (file: File): Promise<string> {
    const url = `${baseUrl}/${uploadNotificationImageEndpoint}`;
    const formData = new FormData();
    formData.append("FileContents", file);
    const response = await authenticatedApi.postFormData(url, formData);
    const data = await response.json();

    // Sans cette garde, une réponse inattendue remonterait `undefined` jusqu'à
    // la campagne, qui partirait sans illustration et sans erreur visible.
    if (!data.imageUrl) {
      throw new Error(i18next.t("platform:notification.noIllustrationUrl"));
    }

    return data.imageUrl;
  },
  detailPlant: async function (plantId: number): Promise<GetPlantDetail> {
    const url = `${baseUrl}/${detailPlantEndpoint}/${plantId}`;
    const response = await authenticatedApi.get(url);
    const data = response.json();
    return data;
  },
  createPlant: async function (plant: CreatePlant): Promise<Response> {
    const url = `${baseUrl}/${createPlantEndpoint}`;
    return await authenticatedApi.post(url, plant);
  },
  updatePlant: async function (plant: UpdatePlantPayload): Promise<Response> {
    const url = `${baseUrl}/${updatePlantEndpoint}`;
    return await authenticatedApi.post(url, plant);
  },
  updatePlantPowerFactor: async (powerFactor: SetPlantPowerFactor) => {
    return await authenticatedApi.post(`${baseUrl}/${updatePlantPowerFactorEndpoint}`, powerFactor, false);
  },
  deletePlant: async function (plantId: number): Promise<Response> {
    const url = `${baseUrl}/${deletePlantEndpoint}`;
    return await authenticatedApi.post(url, {plantId: plantId});
  },
  deleteTracker: async function (trackerId: number): Promise<Response> {
    const url = `${baseUrl}/${deleteTrackerEndpoint}`;
    return await authenticatedApi.post(url, {trackerId: trackerId});
  },
  updateEntityProperty: async function (
    entity: EntityTypeEnum,
    entityId: string | number,
    entityData: EntityProperty[],
  ): Promise<Response> {
    const url = `${baseUrl}/${updateEntityPropertyEndpoint.replace("{entity}", entity).replace("{id}", String(entityId))}`;
    const body = {
      properties: entityData,
    };
    return await authenticatedApi.post(url, body, false);
  },
  updateTrackerPvPanel: async (setPvPanelRequest: SetPvPanel) => {
    return await authenticatedApi.post(`${baseUrl}/${updateTrackerPvPanelEndpoint}`, setPvPanelRequest, false);
  },
  trackerTypes: async function (): Promise<Array<TrackerType>> {
    const url = `${baseUrl}/${trackersTypes}`;
    const response = await authenticatedApi.get(url);
    const data = response.json();
    return data;
  },
  ess: async function (plantId: number): Promise<Response> {
    const url = `${baseUrl}/${essEndpoint}?plant=${plantId}`;
    return authenticatedApi.get(url);
  },
  essStatus: async function (essId: string): Promise<EssStatus> {
    const url = `${baseUrl}/${essStatusEndpoint}/${essId}`;
    const response = await authenticatedApi.get(url);
    return response.json();
  },
  essAlarms: async function (startDate: Dayjs, endDate: Dayjs, essId: string): Promise<Array<EssAlarm>> {
    const url = `${baseUrl}/${essAlarmsEndpoint}?date[after]=${startDate.format("YYYY-MM-DD HH:mm:ss")}&date[before]=${endDate.format("YYYY-MM-DD HH:mm:ss")}&essId=${essId}`;
    const response = await authenticatedApi.get(url);
    const data = response.json();
    return data;
  },
  createAgency: async function (agency: AgencyModel): Promise<Response> {
    const url = `${baseUrl}/${createAgencyEndpoint}`;
    return await authenticatedApi.post(url, agency);
  },
  updateAgency: async function (agency: AgencyModel): Promise<Response> {
    const url = `${baseUrl}/${updateAgencyEndpoint}`;
    return await authenticatedApi.post(url, agency);
  },
  deleteAgency: async function (agencyId: number): Promise<Response> {
    const url = `${baseUrl}/${deleteAgencyEndpoint}`;
    return await authenticatedApi.post(url, {agencyId: agencyId});
  },
  agencies: async function (search?: string, parentId?: number): Promise<Array<GetAgency>> {
    const url = new URL(`${baseUrl}/${agenciesEndpoint}`);
    if (search) {
      url.searchParams.set("search", search);
    }
    if (parentId !== undefined) {
      url.searchParams.set("parentId", String(parentId));
    }
    const response = await authenticatedApi.get(url.href);
    const data = response.json();
    return data;
  },
  equipments: async function (): Promise<Array<Equipment>> {
    const url = `${baseUrl}/${equipmentsEndpoint}`;
    const response = await authenticatedApi.get(url);
    const data = response.json();
    return data;
  },
  mapOfPlantStatuses: async function (
    inAgencies: number[],
    interventionDate: string | null,
    notInPlantStatusTypes: string[],
    notSynchronised: boolean,
    startOperationDate: string | null,
    endOperationDate: string | null,
    platform: string | null,
    plantTags: string[],
    equipments: string[],
    checkpointStatuses: string[],
    references: string[],
  ): Promise<Array<MapOfPlantStatusesItem>> {
    const inAgenciesFilter = inAgencies.length > 0 ? `inAgencies=${inAgencies.toString()}` : null;
    const interventionDateFilter = interventionDate !== null ? `interventionDate=${interventionDate}` : null;
    const notInPlantStatusTypesFilter =
      notInPlantStatusTypes.length > 0 ? `notInPlantStatusTypes=${notInPlantStatusTypes.toString()}` : null;
    const plantTagsFilter = plantTags.length > 0 ? `tags=${plantTags.toString()}` : null;
    const equipmentsFilter = equipments.length > 0 ? `equipments=${equipments.toString()}` : null;
    const checkpointStatusesFilter =
      checkpointStatuses.length > 0 ? `checkpointStatuses=${checkpointStatuses.toString()}` : null;
    const notSynchronisedFilter = !notSynchronised ? `notSynchronised=false` : null;
    const startOperationDateFilter =
      startOperationDate !== null ? `date[startOperationDate]=${startOperationDate}` : null;
    const endOperationDateFilter = endOperationDate !== null ? `date[endOperationDate]=${endOperationDate}` : null;
    const platformFilter = platform !== null ? `platform=${platform}` : null;
    const referencesFilter = references.length > 0 ? `references=${references.join(",")}` : null;
    const filters = [
      inAgenciesFilter,
      interventionDateFilter,
      notInPlantStatusTypesFilter,
      notSynchronisedFilter,
      startOperationDateFilter,
      endOperationDateFilter,
      platformFilter,
      plantTagsFilter,
      equipmentsFilter,
      checkpointStatusesFilter,
      referencesFilter,
    ]
      .filter((x) => x !== null)
      .join("&");
    const url = `${baseUrl}/${mapOfPlantStatusesEndpoint}?${filters}`;
    const response = await authenticatedApi.get(url);
    return response.json();
  },
  currentAlarms: async function (): Promise<Array<CurrentAlarmItem>> {
    const url = `${baseUrl}/${currentAlarmsEndpoint}`;
    const response = await authenticatedApi.get(url);
    return response.json();
  },
  plantStatusTypes: async function (): Promise<Array<PlantStatusType>> {
    const url = `${baseUrl}/${plantStatusTypesEndpoint}`;
    const response = await authenticatedApi.get(url);
    return response.json();
  },
  trackerInternetStatus: async function (
    startDate: Dayjs,
    endDate: Dayjs,
    trackerId: number,
  ): Promise<Array<TrackerInternetStatus>> {
    const url = `${baseUrl}/${trackerInternetStatusEndpoint.replace("{trackerId}", trackerId.toString())}?begin=${startDate.format("YYYY-MM-DD HH:mm:ss")}&end=${endDate.format("YYYY-MM-DD HH:mm:ss")}`;
    const response = await authenticatedApi.get(url);
    return response.json();
  },
  downloadUrlConfigurator: function (os: string): string {
    const url = `${baseUrl}/${downloadConfiguratorEndpoint}/${os}`;
    return url;
  },
  getPvPanelTypes: async (): Promise<PvPanelType[]> => {
    const response = await authenticatedApi.get(`${baseUrl}/${pvPanelTypesEndpoint}`);
    return response.json();
  },
  getAlarmTypes: async (alarmTypeLevels?: number[]): Promise<GetAlarmType[]> => {
    let url = `${baseUrl}/${getAlarmTypesEndpoint}`;
    const params = [];
    if (alarmTypeLevels && alarmTypeLevels.length > 0) {
      params.push(`levels=${alarmTypeLevels.join(",")}`);
    }
    if (params.length > 0) {
      url += `?${params.join("&")}`;
    }
    const response = await authenticatedApi.get(url);
    return response.json();
  },
  getPlantTags: async (search?: string): Promise<Tag[]> => {
    let url = `${baseUrl}/${getPlantTagsEndpoint}`;
    if (search && search !== "") {
      url += `?label=${search}`;
    }
    const response = await authenticatedApi.get(url);
    return response.json();
  },
  getMercureJws: async (topic: string): Promise<Jws> => {
    let url = `${baseUrl}/${getMercureJwsEndpoint}`;
    url += `?topic=${encodeURIComponent(topic)}`;
    const response = await authenticatedApi.get(url, false);
    return response.json();
  },
  alarmEnd: async (alarmId: string, end: string): Promise<Response> => {
    const url = `${baseUrl}/${alarmEndsEndpoint}`;
    const payload = {
      id: alarmId,
      end: end,
    };
    return authenticatedApi.post(url, payload);
  },
  controlPlantStatus: async function (plantId: number): Promise<ControlPlantStatus> {
    const url = `${baseUrl}/${controlPlantStatusEndpoint}/${plantId}`;
    const response = await authenticatedApi.get(url);
    const data = response.json();
    return data;
  },
  solarGatewayStatus: async function (solarGatewayId: string): Promise<SolarGatewayStatus> {
    const url = `${baseUrl}/v2/human/solar_gateways/${solarGatewayId}/status`;
    const response = await authenticatedApi.get(url);
    return response.json();
  },
  solarGatewayAlarms: async function (
    startDate: Dayjs,
    endDate: Dayjs,
    solarGatewayId: string,
  ): Promise<SolarGatewayAlarm[]> {
    let url = `${baseUrl}/v2/human/solar_gateways/${solarGatewayId}/alarms`;
    url += `?date[after]=${startDate.format("YYYY-MM-DD HH:mm:ss")}&date[before]=${endDate.format("YYYY-MM-DD HH:mm:ss")}`;
    const response = await authenticatedApi.get(url);
    return response.json();
  },
  approvePrivacyPolicy: async function (): Promise<Response> {
    const url = `${baseUrl}/${setProfileApprovalEndpoint}`;
    const payload = {
      privacyPolicyAccepted: true,
    };
    return authenticatedApi.post(url, payload);
  },
};

export default apiV2;
